
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class PushNotifyConfigGrid extends Serenity.EntityGrid<PushNotifyConfigRow, any> {
        protected getColumnsKey() { return 'Administration.PushNotifyConfig'; }
        protected getDialogType() { return PushNotifyConfigDialog; }
        protected getIdProperty() { return PushNotifyConfigRow.idProperty; }
        protected getInsertPermission() { return PushNotifyConfigRow.insertPermission; }
        protected getLocalTextPrefix() { return PushNotifyConfigRow.localTextPrefix; }
        protected getService() { return PushNotifyConfigService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}